/**
 * View component for /questions/:questionId/update
 *
 * Updates a single question from a copy of the selcted question
 * as defined in the question reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as questionActions from '../questionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import QuestionForm from '../components/QuestionForm.js.jsx';
import QuestionLayout from '../components/QuestionLayout.js.jsx';

// import question css modules
import questionStyles from '../questionModuleStyles.css';

class UpdateQuestion extends Base {
  constructor(props) {
    super(props);
    const { selectedQuestion, questionMap } = this.props;
    this.state = {
      question: questionMap[selectedQuestion.id] ? { ...questionMap[selectedQuestion.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(questionActions.fetchSingleIfNeeded(match.params.questionId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedQuestion, questionMap } = nextProps;
    this.setState({
      question: questionMap[selectedQuestion.id] ? { ...questionMap[selectedQuestion.id] } : {}
      //we don't want to actually change the store's question, just use a copy
    })
  }

  _handleFormChange(e) {
    let newQuestionState = _.update( this.state.question, e.target.name, function() {
      return e.target.value;
    });
    this.setState({question :newQuestionState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(questionActions.sendUpdateQuestion(this.state.question)).then((action) => {
      if(action.success) {
        history.push(`/questions/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedQuestion, questionMap } = this.props;
    const { question } = this.state;
    const isEmpty = (!question || question._id === null || question._id === undefined);
    return  (
      <QuestionLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedQuestion.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <QuestionForm
                question={question}
                cancelLink={`/questions/${question._id}`}
                formTitle="Update Question"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </QuestionLayout>
    )
  }
}

UpdateQuestion.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedQuestion: store.question.selected
    , questionMap: store.question.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateQuestion)
);



// WEBPACK FOOTER //
// modules/question/views/UpdateQuestion.js.jsx